export default {
  "translation": {
    "card_application": "Demande de carte",
    "card_application_des": "Obtenez une carte Sonic et utilisez-la chez plus de 44 millions de commerçants habilités Visa dans le monde entier.",
    "spend_your_crypto_like_fiat": "Dépenser vos crypto-monnaies comme de la monnaie fiduciaire",
    "use_globally_across_borders": "Utilisez-la dans le monde entier, au-delà des frontières",
    "ultra_low_trans_costs": "Coûts de transaction ultra-faibles",
    "seamless_and_secure": "Sans couture et sécurisé",
    "two_factor_verification": "Vérification à deux facteurs",
    "two_factor_verification_des": "Connectez-vous en toute sécurité en utilisant l'email, le téléphone, la biométrie et/ou l'application d'authentification",
    "safety_pin": "PIN de sécurité",
    "safety_pin_des": "Restreindre l'accès aux informations privées en configurant un PIN",
    "trans_3ds_verification": "Vérification 3DS",
    "trans_3ds_verification_des": "Autoriser les achats avant qu'ils ne soient traités",
    "additional_security": "Sécurité supplémentaire",
    "additional_security_des": "Configurez facilement les limites de carte et d'autres fonctionnalités de sécurité sur l'application",
    "get_your_redotpay_card_in_steps": "Obtenez votre carte Sonic en 3 étapes simples.",
    "get_your_redotpay_card_subtitle": "Utilisez les cryptos comme de la monnaie fiduciaire : Acceptée chez plus de 44M de commerçants compatibles Visa dans le monde entier.",
    "continue_key": "Continuer",
    "bind_your_mobile_number": "Liez votre numéro de mobile",
    "complete_identity_verification": "Complétez la vérification d'identité",
    "apply_a_virtual_or_physical_card": "Demander une carte virtuelle ou physique",
    "transactions": "Transactions",
    "need_mobile_bind_confirm": "Vous devez d'abord lier votre mobile",
    "info": "Info",
    "card_trans_status_refund_pending": "Remboursement en attente",
    "card_trans_status_refund_success": "Remboursement réussi",
    "card_trans_status_refund_fail": "Échec du remboursement",
    "card_trans_status_refund_wait": "Remboursement en attente",
    "card_trans_status_pending": "Autorisé",
    "card_trans_status_cleared": "Débarrassé",
    "card_trans_status_declined": "Refusé",
    "card_trans_status_canceled": "Inversé",
    "card_trans_status_refund": "Remboursement",
    "card_trans_status_refund_cancel": "Annulation de remboursement",
    "refund": "Remboursement",
    "transaction_list": "Liste des transactions",
    "more": "Plus",
    "top_questions": "Questions fréquentes",
    "faq": "FAQ",
    "self_service": "Service autonome",
    "support_center": "Centre de support",
    "hello": "Bonjour",
    "updated_on": "Mis à jour le",
    "chat_with_us": "Discuter avec nous",
    "warning": "Avertissement",
    "security_option_change_alert_prompt": "Après avoir dissocié/modifié Google Authenticator/mobile/email/PIN, le retrait et le transfert interne seront désactivés et les transactions par carte seront limitées à 1000 $ par transaction dans les 24 heures pour des raisons de sécurité.",
    "cancel": "Annuler",
    "ok": "OK",
    "account_deletion_regret_promp": "La suppression de compte vous permet une période de réflexion de 15 jours. Lorsque vous vous reconnectez dans les 15 jours suivant votre demande de suppression, votre demande sera annulée et votre compte pourra continuer à être utilisé normalement.",
    "view_on_blockchain_explorer": "Voir sur l'explorateur de blockchain",
    "biz_sn": "Numéro de transaction",
    "type": "Type",
    "create_time": "Heure de création",
    "logout_confirm": "Êtes-vous sûr de vouloir vous déconnecter?",
    "wallet": "Portefeuille",
    "continue_with_google": "Continuer avec Google",
    "insufficient_balance_deposit_guide": "Solde insuffisant. Déposez des actifs ou vos transactions seront refusées et des frais peuvent être facturés.",
    "to": "À",
    "bill_will_be_sent_to": "Le relevé de facturation sera envoyé à",
    "bill_statement": "Relevé de facturation",
    "export_bill": "Exporter le relevé de facturation",
    "this_month": "Ce mois-ci",
    "last_month": "Le mois dernier",
    "last_3_month": "Les 3 derniers mois",
    "this_year": "Cette année",
    "last_year": "L'année dernière",
    "customize": "Personnaliser",
    "bill_export_success": "Le relevé de facturation a été envoyé à votre email, veuillez vérifier",
    "bill_empty": "Votre relevé est vide",
    "channel": "Canal",
    "merchant_country": "Pays du commerçant",
    "status": "Statut",
    "withdraw_detail": "Détails du retrait",
    "new_key": "Nouveau",
    "deposit": "Dépôt",
    "withdraw": "Retrait",
    "single_limit": "Limite unique",
    "all": "TOUT",
    "minimum": "Minimum",
    "available": "Disponible",
    "received_amount": "Montant reçu",
    "withdrawl": "Retrait",
    "network_fee": "Frais de réseau",
    "register": "S'inscrire",
    "register_login": "S'inscrire/Se connecter",
    "login": "Se connecter",
    "email_Phone": "Email/Numéro de téléphone",
    "email": "Email",
    "mobile": "Mobile",
    "next": "Suivant",
    "or_continue_with": "Ou continuez avec",
    "forgot_pw": "Mot de passe oublié?",
    "welcome_to_redotpay": "Bienvenue chez Sonic Pay",
    "verify_code": "Vérifier le code",
    "get_code": "Obtenir le code",
    "by_creating_an_account": "En créant un compte, vous acceptez notre",
    "privacy_policy": "politique",
    "terms_conditions": "Conditions générales",
    "and": "et",
    "modify_pin": "Modifier le PIN",
    "pin_subtitle": "Le PIN de sécurité permet une vérification rapide, facilitant l'affichage des numéros de carte et des informations CVV.",
    "password_set_first_login": "Première connexion pour définir le mot de passe",
    "next_step": "Étape suivante",
    "confirm": "Confirmer",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "send_code": "Envoyer le code",
    "send_code_to": "Le code sera envoyé à",
    "switch_option": "Changer d'option de vérification",
    "mobile_verification": "Vérification mobile",
    "email_verification": "Vérification par email",
    "choose_verify_method": "Changer d'option de vérification",
    "verify_pin": "PIN de sécurité",
    "google_authenticator_verification": "Vérification Google Authenticator",
    "security": "Sécurité",
    "bound": "Lié",
    "unbound": "Non lié",
    "set": "Définir",
    "unset": "Non défini",
    "update_pw": "Changer le mot de passe",
    "delete_account": "Annuler le compte",
    "google_authenticator": "Google Authenticator",
    "google_authenticator_subtitle": "Google Authenticator protège vos retraits et votre compte.",
    "download_install": "Télécharger",
    "download_install_prompt": "Vous devez d'abord télécharger et installer l'application Authenticator (Google Authenticator)",
    "backup_key": "Clé de sauvegarde",
    "save_backup_key": "Sauvegardez cette clé de sauvegarde dans un endroit sûr",
    "google_authenticator_code": "Code Google Authenticator",
    "email_subtitle": "La vérification par email protège vos retraits et votre compte.",
    "change_email": "Changer l'email",
    "email_update": "Mise à jour de l'email",
    "code": "Code",
    "mobile_subtitle": "La vérification mobile protège vos retraits et votre compte.",
    "change_mobile": "Changer le mobile",
    "mobile_update": "Mise à jour du mobile",
    "mobile_bind": "Lier le téléphone mobile",
    "email_bind": "Lier l'email",
    "old_password": "Ancien mot de passe",
    "new_password": "Nouveau mot de passe",
    "new_password_confirm": "Confirmation du nouveau mot de passe",
    "language": "Langue",
    "appearance": "Apparence",
    "logout": "Déconnexion",
    "log_out_toast": "Vous avez été déconnecté",
    "set_pin": "PIN de sécurité",
    "account_deletion_prompt_1": "Ce compte ne sera jamais récupéré",
    "account_deletion_prompt_2": "Tous les sous-utilisateurs/autres comptes créés par ce compte seront supprimés et ne pourront pas être récupérés.",
    "account_deletion_prompt_3": "Toutes les clés API associées à ce compte seront supprimées.",
    "account_deletion_prompt_4": "Tous les retraits de devises délégués et en attente de ce compte seront annulés.",
    "account_deletion_prompt_5": "Toutes les fonctions de transaction de ce compte seront désactivées.",
    "account_deletion_prompt_6": "Les actifs non retirés de ce compte seront considérés comme des actifs abandonnés volontairement.",
    "account_deletion_prompt_7": "Après avoir supprimé une demande de compte, vous pouvez bénéficier d'une période de retrait de 15 jours. Lorsque vous vous reconnectez dans les 15 jours suivant la demande de suppression, votre demande de suppression sera annulée et le compte pourra continuer à être utilisé normalement.",
    "kyc_status_0": "Non soumis",
    "kyc_status_1": "Vérification...",
    "kyc_status_2": "Approuvé",
    "kyc_status_3": "Échec de l'audit",
    "kyc_status_4": "Soumis à nouveau",
    "kyc_status_5": "Soumettre à l'amont",
    "personal_info_review": "Revue des informations personnelles",
    "additional_info_request": "Demande d'informations supplémentaires",
    "verifying": "Vérification...",
    "form_submitted_will_review_asap_new": "Votre demande a été soumise pour une révision manuelle. Le processus prend généralement 3 à 5 jours, mais peut parfois prendre plus de temps. Veuillez faire preuve de patience.",
    "get_verified": "Vérification d'identité",
    "kyc_verified": "Identité de l'utilisateur vérifiée",
    "approved": "Approuvé",
    "not_able_to_submit_identity": "Dans le cadre de notre processus de vérification complet, nous vous demandons des informations supplémentaires pour compléter les procédures de connaissance du client (KYC) et de lutte contre le blanchiment d'argent (AML).",
    "aml_review_failed": "Pour poursuivre votre demande, veuillez cliquer sur le bouton ci-dessous pour accéder et remplir le formulaire d'auto-déclaration.",
    "aml_declaration_prompt": "Veuillez noter que le non-respect de la fourniture du formulaire demandé dans les 14 jours entraînera le refus de votre demande.",
    "verify_your_identity": "Vérifiez votre identité",
    "get_identity_verified": "Faites vérifier votre identité pour acheter et utiliser la carte",
    "country_region": "Pays/Région",
    "given_name": "Prénom",
    "surname": "Nom de famille",
    "date_of_birth": "Date de naissance",
    "document_type": "Type de document",
    "document_number": "Numéro de document",
    "given_name_intl": "Prénom (INTL)",
    "surname_intl": "Nom de famille (INTL)",
    "click_to_add_signature": "Cliquez pour ajouter une signature",
    "rewrite": "Réécrire",
    "submit": "Soumettre",
    "save": "Enregistrer",
    "accounts_are_not_available": "Les comptes ne sont pas disponibles",
    "abandon_assets": "Abandonner les actifs {{amount}} {{currency}}",
    "account_deletion_successful": "Suppression de compte réussie",
    "passwords_do_not_match": "Les mots de passe ne correspondent pas",
    "password_reset_success": "Réinitialisation du mot de passe réussie",
    "password_confirm": "Confirmation du mot de passe",
    "is_refund": "Remboursement",
    "total_debt": "Total de la dette",
    "your_account_is_in_arrears": "Votre compte est en souffrance. Veuillez déposer des fonds suffisants pour régler le solde. Votre compte/carte sera restauré lorsque votre solde sera ≥10 USD après le remboursement de la dette.",
    "repayment": "Remboursement",
    "debit_record": "Enregistrement de débit",
    "no_data": "Données vides",
    "payment": "Paiement",
    "transaction_details": "Détails de la transaction",
    "transaction_date": "Date de la transaction",
    "transaction_id": "ID de transaction",
    "view_linked_order": "Voir la commande liée",
    "rights_interests": "Droits et intérêts",
    "transaction_limit": "Limite de transaction",
    "deposit_withdraw": "Dépôt et retrait",
    "card_purchased_number": "Nombre de cartes disponibles à l'achat",
    "on_review_your_applicant": "Nous examinons votre demande",
    "form_en_only": "Le formulaire ne peut être rempli qu'en anglais",
    "available_to_spend": "Disponible à dépenser",
    "get_a_card": "Obtenez une carte Sonic et utilisez-la chez plus de 44 millions de commerçants habilités Visa dans le monde entier.",
    "virtual_card": "Carte virtuelle",
    "physical_card": "Carte physique",
    "apply_card": "Demander une carte",
    "enjoy_seamless_spending": "Dépenser",
    "spend_and_withdraw": "Dépenses et retrait aux DAB",
    "card_labeling": "Étiquetage de carte",
    "card_tag": "Étiquette de carte",
    "edit_billing_address": "Adresse de facturation",
    "government_issued_id": "ID délivré par le gouvernement",
    "facial_recognition": "Reconnaissance faciale",
    "address": "Adresse",
    "personnel_information_details": "Détails des informations personnelles",
    "nation_list": "Liste des nations",
    "choose_channel": "Mode de vérification",
    "mobile_channel_sms": "SMS",
    "mobile_channel_smsAliyunWhatsApp": "WhatsApp",
    "card_application_order": "Commande de demande de carte",
    "promo_code_optional": "Code promotionnel (facultatif)",
    "promo_code": "Code promotionnel",
    "billing_address": "Adresse de facturation",
    "shipping_address": "Adresse de livraison",
    "shipping_to": "Expédition vers",
    "card_purchase_fee": "Frais d'achat de carte",
    "card_holder_name": "Nom du titulaire de la carte",
    "city": "Ville",
    "province_state": "Province/État",
    "postal_code": "Code postal",
    "address_line1": "Adresse",
    "address_line2": "Ligne d'adresse 2",
    "please_fill_in_the_information_in_english": "Le formulaire ne peut être rempli qu'en anglais",
    "first_name": "Prénom",
    "last_name": "Nom de famille",
    "country_code": "Code du pays",
    "card_application_list": "Liste des demandes de carte",
    "buy_virtual_card": "Acheter une carte virtuelle",
    "buy_physical_card": "Acheter une carte physique",
    "withdraw_list": "Liste des retraits",
    "no_more_data": "Plus de données",
    "select_a_network": "Sélectionnez un réseau",
    "please_select_network": "Veuillez sélectionner un réseau",
    "select_a_network_ensure": "Assurez-vous que le réseau choisi pour le dépôt correspond au réseau de retrait, sinon des actifs peuvent être perdus.",
    "network": "Réseau",
    "card_management": "Gestion de carte",
    "freeze": "Geler",
    "unfreeze": "Débloquer",
    "freeze_card_des": "Une fois la fonction de verrouillage par un bouton activée, vous ne pourrez pas utiliser cette carte, mais cela n'affectera pas les autres cartes. Si vous souhaitez annuler la fonction de verrouillage par un bouton, vous pouvez l'activer ici à nouveau.",
    "freezing_trades": "Geler une carte produit une commande échouée, causant un échec de transaction ou des frais supplémentaires pour des transactions refusées.",
    "unfreeze_your_card_desc": "Une fois la fonction de verrouillage par un bouton désactivée, vous pourrez utiliser cette carte à nouveau, et cela n'affectera pas les autres cartes. Si vous souhaitez geler la carte, vous pouvez le faire ici à nouveau.",
    "card_tag_set_success": "Étiquette de carte définie avec succès",
    "bill": "Facture",
    "setting": "Paramètre",
    "limit": "Limite",
    "assets_list": "Liste des actifs",
    "empty_data": "Données vides",
    "deposit_list": "Liste des dépôts",
    "date": "Date",
    "merchant_city": "Ville du marchand",
    "card_number": "Numéro de carte",
    "card_type": "Type de carte",
    "mcc": "MCC",
    "declined_reason": "Raison du refus",
    "card_authorization_payment": "Paiement par autorisation de carte",
    "declined_transaction_fee": "Frais de transaction refusée",
    "verified": "Vérifié",
    "notifications": "Notifications",
    "need_to_add_bill_address": "Besoin d'ajouter une adresse de facturation",
    "need_to_add_shipping_address": "L'adresse de livraison ne peut pas être vide",
    "success": "Succès",
    "welcome_redotpay": "Bienvenue chez Sonic Pay !",
    "reset_pw_alert": "Après avoir changé de mot de passe, les retraits et les transferts internes seront désactivés et les transactions par carte seront limitées à 1000 $ par transaction dans les 24 prochaines heures pour des raisons de sécurité.",
    "no_more_records": "Plus d'enregistrements",
    "add": "Ajouter",
    "address_label": "Étiquette d'adresse",
    "add_address": "Ajouter une adresse",
    "this_field_is_required": "Ce champ est requis",
    "ID_CARD": "Carte d'identité",
    "PASSPORT": "Passeport",
    "DRIVERS": "Permis de conduire",
    "RESIDENCE_PERMIT": "Permis de séjour",
    "amount": "Montant",
    "withdraw_status_waiting": "En attente",
    "withdraw_status_pending": "En attente",
    "withdraw_status_success": "Succès",
    "withdraw_status_fail": "Échec",
    "withdraw_status_canceled": "Annulé",
    "withdraw_status_declined": "Refusé",
    "withdraw_status_complete": "Complété",
    "order_id": "ID de commande",
    "click_or_scroll_to_load_more": "Cliquez ou faites défiler pour charger plus",
    "minimum_deposit_amount": "Montant minimum de dépôt",
    "deposit_arrival_confirmations": "Arrivée du dépôt : {{confirmations}} confirmations",
    "confirmations": "{{confirmations}} Confirmations",
    "deposit_network": "Réseau de dépôt",
    "minimum_deposit": "Dépôt minimum",
    "deposit_arrival": "Arrivée du dépôt",
    "current_address_supports_depositing": "L'adresse actuelle ne prend en charge que le dépôt de {{varietyCode}} sur {{displayName}}, et d'autres actifs seront perdus.",
    "copy_successful": "Copie réussie",
    "update_password_successful": "Mise à jour du mot de passe réussie",
    "update_successful": "Mise à jour réussie",
    "successful": "Réussi",
    "signature_required": "Signature requise",
    "deposit_successful": "Dépôt réussi",
    "sign_out": "Déconnexion",
    "cancel_withdraw_order_success": "Annulation de la commande de retrait réussie",
    "delete_successful": "Suppression réussie",
    "unfreeze_card_successful": "Déblocage de la carte réussi",
    "card_nickname_set_success": "Surnom de carte défini avec succès",
    "trans_limit_adjusted_success": "Limite de transaction ajustée avec succès",
    "set_card_pin_success": "PIN de carte défini avec succès",
    "withdraw_apply_commit_please_wait": "Demande de retrait soumise, veuillez patienter",
    "unfreeze_success": "Déblocage réussi",
    "freeze_success": "Gel réussi",
    "withdraw_duration_tip": "Les demandes de retrait seront traitées dans un délai d'un jour ouvrable",
    "you_will_withdraw": "Vous retirez",
    "withdraw_info": "Informations de retrait",
    "please_confirm_same_network": "Assurez-vous que le réseau choisi pour le dépôt correspond au réseau de dépôt, sinon des actifs peuvent être perdus.",
    "cancel_withdraw_order_confirm": "Êtes-vous sûr de vouloir annuler le retrait ?",
    "valid_thru": "valide jusqu'au",
    "last_7_days": "Derniers 7 jours",
    "last_30_days": "Derniers 30 jours",
    "today": "Aujourd'hui",
    "all_done": "Tout est fait",
    "view_details": "Voir les détails",
    "withdraw_success": "Retrait réussi",
    "pay": "Payer",
    "fee": "frais",
    "discount": "Remise",
    "price": "Prix",
    "card_application_details": "Détails de la demande de carte",
    "card_pin": "PIN de carte",
    "card_pin_format_helper": "Ne peut pas contenir trois chiffres identiques consécutifs ou des chiffres séquentiels",
    "digit_variable": "{{count}} chiffre",
    "address_book": "Carnet d'adresses",
    "unlimited": "Illimité",
    "single": "Unique",
    "update_card_pin": "Mettre à jour le PIN de la carte",
    "set_card_pin": "Définir le PIN de la carte",
    "report_lost": "Déclarer perdu",
    "report_lost_card": "Déclarer la carte perdue",
    "card_lost_report_alert": "Après avoir signalé la perte, la carte sera désactivée et vous ne pourrez pas changer le statut. Si vous souhaitez utiliser à nouveau la carte ou demander une nouvelle carte, veuillez contacter le service client.",
    "pending": "En attente",
    "frozen": "Gelé",
    "phone_number": "Numéro de téléphone",
    "search": "Recherche",
    "reset": "Réinitialiser",
    "total_amount": "Montant total",
    "actual_amount": "Montant réel",
    "already_have_an_account": "Vous avez déjà un compte ?",
    "create_account": "Créer un compte Sonic Pay",
    "total_balance": "Solde total",
    "cards_balance_available_promp": "Limite de crédit calculée en temps réel sur la base des actifs du portefeuille",
    "got_it": "Compris",
    "review_details": "Examiner les détails",
    "delete_this_address": "Êtes-vous sûr de vouloir supprimer cette adresse ?",
    "currency": "Monnaie",
    "merchant_name": "Nom du marchand",
    "request_time": "Heure de la demande",
    "is_transaction_allowed": "Cette transaction est-elle autorisée ?",
    "approve": "Approuver",
    "decline": "Décliner",
    "card_in_production": "Carte en production",
    "redotpay_card_sent": "Carte Redotpay envoyée",
    "redotpay_card_activated": "Carte Redotpay activée",
    "activate_card": "Activer la carte",
    "paste": "Coller",
    "fees_included": "Frais inclus",
    "fx_fee": "Frais de change",
    "small_auth_fee": "Frais de petite transaction",
    "atm_fee": "Frais de retrait",
    "received": "Reçu",
    "incremental": "Frais incrémentiels",
    "bill_address_save_success": "Adresse de facturation enregistrée avec succès",
    "no_more_trans_record": "Plus aucun enregistrement de transaction",
    "withdraw_amount_larger_than_available": "Dépasse le solde disponible maximum",
    "withdraw_lower_than_min": "Inférieur au montant minimum de retrait",
    "card_is_deleted": "Carte supprimée",
    "something_error": "Quelque chose s'est mal passé",
    "home": "Accueil",
    "select_country": "Sélectionner le pays",
    "billing_list": "Liste de facturation",
    "coupon_code": "code promo",
    "password_rule1": "De 8 à 32 caractères",
    "password_rule2": "Au moins une lettre majuscule anglaise",
    "password_rule3": "Au moins une lettre minuscule anglaise",
    "password_rule4": "Au moins un chiffre",
    "set_pw": "Configurer le mot de passe",
    "payment_currency_settings": "Paramètres de la devise de paiement",
    "customize_payment_currency": "Personnaliser la devise de paiement",
    "disable_non_local_tip": "Désactiver les transactions en devises non locales peut réduire efficacement les risques de fraude à la carte",
    "charging_rules": "Règles de facturation",
    "reissue_card": "Réémettre une carte",
    "update_cvv": "Mettre à jour le CVV",
    "update_cvv_desc": "Même numéro de carte, nouveau CVV et nouvelle date d'expiration.",
    "reissue_fee": "Frais de réémission",
    "fx_fee_desc": "Les frais de change (frais FX) incluent 1,2 % de frais de transaction en devise non par défaut (le cas échéant).",
    "atm_fee_desc": "Des frais supplémentaires de 2 % seront facturés pour chaque retrait aux distributeurs automatiques.",
    "remit_fee_desc": "Frais pour l'utilisation d'une carte de crédit ou de débit Visa.",
    "risk_safety_tips": "Conseils de sécurité",
    "risk_safety": "Pour des raisons de sécurité, veuillez compléter la vérification par reconnaissance faciale sur l'application avant de poursuivre toute opération liée.",
    "go_to_app_verify": "Aller sur l'application pour vérifier",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "Aller sur RedotPay maintenant",
    "close": "Fermer",
    "card_cancellation": "Annulation de la carte",
    "delete_card": "Supprimer la carte",
    "delete_card_desc": "La carte sera inutilisable après la suppression, et cette action est irréversible.",
    "deleting_fee": "Frais de suppression",
    "currency_tips": "Conseils sur les devises",
    "at_least_one_currency": "Veuillez conserver au moins une devise payable.",
    "all_select_currency": "Vous soutenez déjà toutes les devises pour effectuer des transactions.",
    "small_auth_transaction_fee_stas": "Détails des frais de petites transactions",
    "small_transactions_this_month": "Petites transactions ce mois-ci",
    "small_autn_trans_remain": "Nombre de petites transactions exonérées de frais ce mois-ci",
    "rules": "Règles",
    "failed_rules": "Les transactions échouées augmenteront le nombre d'enregistrements de transactions incorrectes, et des frais supplémentaires seront ajoutés si vous les dépassez. Veuillez réguler la transaction.",
    "rule_item": "Article",
    "free_count": "Nombre gratuit",
    "fees": "Frais",
    "declined_trans_remain": "Nombre de transactions refusées exonérées de frais ce mois-ci",
    "declined_transaction_fee_stats": "Statistiques des frais de transactions refusées",
    "declined_rules": "Les transactions échouées augmenteront le nombre d'enregistrements de transactions incorrectes, et des frais supplémentaires seront ajoutés si vous les dépassez. Veuillez réguler la transaction.",
    "declined_transactions_this_month": "Nombre de transactions refusées ce mois-ci",
    "card_trans_detail_status_refund": "Remboursement en cours",
    "card_trans_status_reversal": "Annulation",
    "card_trans_status_fully_refund": "Traitée, remboursement complet émis",
    "card_trans_status_partial_refund": "Traitée, remboursement partiel émis",
    "card_trans_status_void": "Annulée",
    "first_time_free": "Gratuit pour la première fois",
    "FxFee": "Frais de change",
    "AtmFee": "Frais de DAB",
    "RemitFee": "Frais de remise",
    "MccFee": "Frais MCC",
    "mcc_fee_desc": "Certains commerçants factureront des frais supplémentaires de 1,5 % du montant de la transaction. Si les frais sont inférieurs à 0,5 USD, un minimum de 0,5 USD sera appliqué.",
    "please_deposit": "Veuillez déposer",
    "special_mcc_fee": "Frais MCC spéciaux",
    "bank_verifying": "Ce remboursement est en cours de vérification par la banque…",
    "estimate_time": "Temps estimé pour l'arrivée : 2 à 30 jours",
    "delete_out": "Déconnexion",
    "card_is_loss": "La carte a été déclarée perdue",
    "incremental_desc": "Si le montant autorisé est insuffisant, des frais supplémentaires seront appliqués et le montant correspondant sera ajouté lors du règlement.",
    "card_trans_status_fully_refund1": "Apuré",
    "card_trans_status_fully_refund2": "Entièrement remboursé",
    "card_trans_status_partial_refund1": "Apuré",
    "card_trans_status_partial_refund2": "Remboursé partiellement",
    "review_takes_time": "L'examen prend de 2 minutes à 24 heures.",
    "custom_date_null": "Veuillez sélectionner une date personnalisée",
    "custom_date_error": "Veuillez définir le temps de requête correct",
    "small_trade_fee": "Frais de petite transaction",
    "user_risk_exception": "Exception d'état de l'utilisateur",
    "request_exception": "Erreur de demande",
    "mobile_is_not_empty": "Veuillez entrer un numéro de mobile valide",
    "code_is_not_empty": "Veuillez entrer un code de vérification valide",
    "browser_paste_error": "Restrictions du navigateur, veuillez saisir manuellement"
  }
};